import { InlineCalendar } from "PFComponents/calendar/inline_calendar";
import { Label } from "PFComponents/label";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { FilterWithDefaults } from "PFTypes";
import { RefObject } from "react";

import { letFilterRestore } from "../../use_filtered_collection";

type DateItemProps = {
  handleChange: (value: string | null) => void;
  filter: FilterWithDefaults;
  error?: string;
  portalRef?: RefObject<HTMLElement | null>;
  disabled?: boolean;
};

export const DateItem = ({ filter, handleChange, error, portalRef, disabled }: DateItemProps) => {
  const { formatDate } = useDateFormatter();
  const letRestore = letFilterRestore(filter);

  return (
    <div style={{ position: "relative" }}>
      {filter.title && <Label text={filter.title} required={filter.required} />}
      <InlineCalendar
        style={{ marginLeft: -10 }}
        error={error}
        selectedDate={filter.value ? formatDate(filter.value as string) : null}
        displayValue={filter.value ? formatDate(filter.value as string) : null}
        handleChange={(value) => handleChange(value)}
        letClear={!filter.required}
        onRestore={
          letRestore
            ? () => handleChange((filter.defaultValue ?? filter.default_value) as string | null)
            : undefined
        }
        portalRef={portalRef}
        disabled={disabled}
      />
    </div>
  );
};
